import {ChangeDetectionStrategy, Component, ViewEncapsulation} from '@angular/core';

@Component({
	selector: 'not-found-page',
	standalone: true,
	imports: [],
	templateUrl: './not-found.page.html',
	styleUrl: './not-found.page.scss',
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotFoundPage {

}
